var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemUploadFileAttachment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M19.001 18h-14a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2M8.488 9.995l2.446-2.41v7.971c0 .581.477 1.051 1.067 1.051s1.066-.47 1.066-1.05V7.585l2.446 2.409c.208.205.481.308.754.308s.547-.103.755-.308a1.04 1.04 0 0 0 0-1.486l-4.266-4.201a1.083 1.083 0 0 0-1.51 0L6.98 8.509a1.04 1.04 0 0 0 0 1.486c.417.41 1.09.41 1.508 0"
})));
export default SvgGemUploadFileAttachment;